import React, { Component } from "react";
import PMIICDateRangePicker from "../../component/PMIICDateRangePicker";
import isFunction from "lodash/isFunction";
import { Prev } from "react-bootstrap/PageItem";

let startTimestamp = null;
let endTimestamp = null;

class CalendarFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cal: false,
      show: false,
      date: {},
      selectedDate: null,
      isActive: "",
      pendingActive: "",
      disabledDays: new Date(),
      tillYear: new Date().getFullYear()
    };
  }

  // componentDidMount() {
  //   const { defaultDates } = this.props;
  //   if (defaultDates && defaultDates.createdDate) {
  //     startTimestamp = defaultDates.createdDate.from;
  //     endTimestamp = defaultDates.createdDate.to;
  //     this.setState(
  //       {
  //         date: { start: startTimestamp, end: endTimestamp },
  //         displayText: defaultDates.displayText
  //       },
  //       () => {
  //         this.onSubmit();
  //       }
  //     );
  //   }
  // }

  // componentWillReceiveProps(nextProps, nextContext) {
  //   const { defaultDates } = nextProps;
  //   const { defaultDates: oldDefaultDates } = this.props;
  //   if (defaultDates !== oldDefaultDates) {
  //     this.setState({
  //       date: defaultDates,
  //       displayText: defaultDates.displayText || "- Created Date -"
  //     });
  //   }
  // }

  onHandleCal = () => {
    this.setState({
      show: true
    });
    if (window.scrollY === 0) window.scrollBy({ top: 150, behavior: "smooth" });
  };

  handleSelect = (range, isActive, initial) => {
    this.setState(prev => ({ isActive: prev.pendingActive }));
    let date = new Date(startTimestamp);
    let startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    startDate.setHours(0, 0, 0);
    // range.startDate.setHours(0, 0, 0);
    // range.endDate.setHours(23, 59, 59, 999);
    range.from.setHours(0, 0, 0);
    range.to != null
      ? range.to.setHours(23, 59, 59, 999)
      : range.from.setHours(23, 59, 59, 999);
    startTimestamp = Date.parse(range.from);
    endTimestamp =
      range.to != null ? Date.parse(range.to) : Date.parse(range.from);
    this.setState(
      {
        date: { start: range.from, end: range.to },
        selectedDate: {
          from: range.from,
          to: range.to != null ? range.to : range.from
        },
        range,
        displayText:
          this.GetFormattedDate(startTimestamp) +
          " to " +
          this.GetFormattedDate(endTimestamp)
      },
      () => {
        if (this.props.getFilterArrayValue) {
          const { filterArray } = this.props;
          this.props.getFilterArrayValue(filterArray, this.state.displayText);
        }
        if (this.props.onChange) {
          this.props.onChange({
            createdDate: { from: startTimestamp, to: endTimestamp },
            dates: this.state.displayText,
            sortOrder: "ASC"
          });
        }
      }
    );
  };

  handleClose = () => {
    this.setState(prevState => ({
      show: false,
      cal: false,
      displayText: this.props.isDashboard ? "All" : prevState.displayText,
      pendingActive: prevState.isActive,
      selectedDate: prevState.range,
      date: this.state.date
    }));
  };

  handleShow = () => {
    this.setState({
      show: true,
      cal: false
    });
  };

  GetFormattedDate = date => {
    let todayTime = new Date(date);
    let day = String(todayTime.getDate()).padStart(2, "0"); // ensure 2 digits
    let month = String(todayTime.getMonth() + 1).padStart(2, "0");
    let year = todayTime.getFullYear();

    return `${day}/${month}/${year}`;
  };

  onSubmit = (ranges, isActive) => {
    const { onChange } = this.props;
    if (ranges) {
      this.handleSelect(ranges, isActive);
    } else {
      onChange({
        createdDate: { from: startTimestamp, to: endTimestamp },
        dates: this.state.displayText,
        sortOrder: "ASC"
      });
    }

    this.setState({
      show: false,
      cal: false
    });
  };

  onChangeSort = ({ value: name, title: text }) => {
    let { onChange } = this.props;
    let currentTimeStamp = Date.parse(new Date());
    const date = new Date();
    let createdDate = {};
    let nameIsAct = "";
    switch (name) {
      case "All":
        nameIsAct = "All";
        createdDate = {
          from: Date.parse(new Date(2013, 1, 1)),
          to: currentTimeStamp
        };
        break;
      case "This Month":
        nameIsAct = "This Month";
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();

        const firstDayOfMonth = new Date(year, month, 1);
        createdDate = {
          from: Date.parse(firstDayOfMonth),
          to: currentTimeStamp
        };
        break;

      case "currentMonth":
        nameIsAct = "Current Month";
        createdDate = {
          from: Date.parse(new Date(date.getFullYear(), date.getMonth(), 1)),
          to: currentTimeStamp
        };
        break;
      case "7":
        date.setDate(date.getDate() - 7);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "30":
        date.setDate(date.getDate() - 30);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "180":
        nameIsAct = "Last 6 Months";
        date.setDate(date.getDate() - 180);
        createdDate = {
          from: Date.parse(date),
          to: currentTimeStamp
        };
        break;
      case "Since Inception":
        nameIsAct = "Since Inception";
        createdDate = {
          from: new Date(2013, 0, 1, 0, 0, 0, 0),
          to: currentTimeStamp
        };
        break;
      case "PMG Merger":
        nameIsAct = "Since PMG Merger";
        createdDate = {
          from: Date.parse("Feb 14, 2019"),
          to: currentTimeStamp
        };
        break;
      case "365":
        nameIsAct = "This Year";
        const fullCurrentYear = new Date(date.getFullYear(), 0, 1);
        createdDate = {
          from: Date.parse(fullCurrentYear),
          to: currentTimeStamp
        };
        break;
      default:
        break;
    }
    this.setState(
      {
        cal: false,
        displayText: text,
        range: null,
        selectedDate: createdDate,
        pendingActive: nameIsAct
      }
      // () => {
      //   isFunction(onChange) && onChange({ createdDate, dates: text });
      // }
    );
  };

  resetPendingActive = () => {
    this.setState({ pendingActive: null });
  };

  render() {
    const { cal, show, range } = this.state;
    const { displayDateTitle = "All", calenderOptions = [] } = this.props;

    return (
      <React.Fragment>
        <div
          className={`dropdown field-calendar-filter`}
          onClick={this.onHandleCal}
        >
          <div className={`dropdown-overlay `} />
          <div className="dropdown-selected-value">{displayDateTitle}</div>
          {/* <div className="dropdown-option-list">
            {calenderOptions.map(option => {
              return option.value ? (
                <div
                  onClick={e => {
                    this.onChangeSort(option);
                  }}
                >
                  {option.title}
                </div>
              ) : (
                <div onClick={this.handleShow}>{option.title}</div>
              );
            })}
          </div> */}

          <PMIICDateRangePicker
            show={this.state.show}
            handleSelect={this.handleSelect}
            range={range}
            calenderOptions={calenderOptions}
            changSort={this.onChangeSort}
            onSubmit={this.onSubmit}
            handleClose={this.handleClose}
            selectedDate={this.state.selectedDate}
            isActive={this.state.isActive}
            disabledDays={this.state.disabledDays}
            tillYear={this.state.tillYear}
            pendingActive={this.state.pendingActive}
            fromToDate={this.state.date}
            resetPendingActive={this.resetPendingActive}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default CalendarFilter;
